<div class="e-modal-container">
    <div class="e-dialog-title">
        <h1>Currency Conversion Table</h1>
        <button class="fa fa-times" (click)="closeClicked()"></button>
    </div>
    <div class="e-dialog-content">
        <div class="e-rate-row-header">
            <h2>Selected<br />Currency</h2>
            <h2>Local<br />Currency</h2>
            <h2>Default<br />Exchange Rate</h2>
        </div>
        <ng-container *ngFor="let rate of data.exchangeRateData">
            <div class="e-rate-row">
                <div>{{ data.selectedCurrency }}</div>
                <div>
                    <span matTooltipClass="e-mat-tooltip"
                        matTooltipPosition="below"
                        matTooltip="{{ rate.fullName }}"
                        matTooltipShowDelay="500">
                        {{ rate.name }}
                    </span>
                </div>
                <div>{{ rate.defaultValue }}</div>
            </div>
        </ng-container>
    </div>
</div>
